module.exports = __webpack_public_path__ + "media/images/email-icon-fbd12b4e134a9f44dc28d5b5aadaf883.svg";